export enum DemeritType {
  NoShow,
}

export interface IDemerit {
  type: DemeritType;
  date: Date;
  timezone: string;
  sessionTime: Date;
  weight: number;
}
